export const MAIN_CONTAINER_HEIGHT = 1000;
export const MODAL_ANIMATION_DURATION = 300;

export const MODAL_ANIMATION_SLIDE_POSITIONS = {
  left: {
    open: [-100, 0],
    close: [0, -100],
  },
  right: {
    open: [100, 0],
    close: [0, 100],
  },
};
